import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right_angle",
  "use": "icon-right_angle-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-right_angle\"><defs><style type=\"text/css\"></style></defs><path d=\"M663.394 506.649L288.627 131.882c-12.496-12.497-12.496-32.758 0-45.255 12.497-12.496 32.758-12.496 45.255 0l403.051 403.051c12.497 12.497 12.497 32.758 0 45.255l-403.05 403.051c-12.498 12.497-32.759 12.497-45.256 0-12.496-12.497-12.496-32.758 0-45.255l374.767-374.766a8 8 0 0 0 0-11.314z\" p-id=\"2324\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol